import _ from 'lodash'

const keyList = [
  'G-90KTJQL7VZ'
]

function gtag () {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(arguments)
}

export function setup () {
  if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_ENV !== 'production') {
    return null
  }
  window.dataLayer = window.dataLayer || []
  window.gtag = gtag
  const jsLoaderList = _.map(keyList, (key) => new Promise((resolve, reject) => {
    if (document.getElementById(key)) {
      resolve()
    }
    const script = document.createElement('script')
    script.id = key
    script.src = `https://www.googletagmanager.com/gtag/js?id=${key}`
    script.async = true
    script.onload = resolve
    script.onerror = reject
    const content = (document.head || document.body)
    content.appendChild(script)
    gtag('js', new Date())
    gtag('config', key)
  }))
  return Promise.all(jsLoaderList)
}
